<ng-container [ngSwitch]="type" *ngIf="history">
  <ng-container *ngIf="history.date">Prüfung: {{ history.date }},</ng-container>
  <ng-container *ngIf="history.quantity">Menge: {{ history.quantity|money }}</ng-container>
  <ng-container *ngIf="history.inspection_plan_extra">Sonderprüf.: {{ history.inspection_plan_extra }}</ng-container>
</ng-container>
